import React from "react";
import { createRoot } from "react-dom/client";
import JoybaseJpApp from "../pages/joybase-jp/App";

import '../index.css'

const rootElement = document.getElementById("react-root");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<JoybaseJpApp />);
}
